import request from '@/utils/request'
const apiPath = '/cust/customerRegistration'
const customerRegistrationApi = {
  /**
   * 新增修改【客户证件】
   */
  create(data) {
    return request.post(`${apiPath}/saveorupdate`, data)
  },
  addPayWK(data) {
    return request.post(`${apiPath}/addPayWK`, data)
  },
  /**
   * 分页查询【客户报名】
   */
  fetchList(query) {
    return request.get(`${apiPath}/list2`, { params: query })
  },
  /**
   * 同意【客户证件】
   */
  agreeApply(query) {
    return request.get(`${apiPath}/AgreeCustomerCertificates`,{ params: query })
  },
  registrationExport(query) {
    return request.get(`${apiPath}/registrationExport`,{ params: query })
  },
  /**
   * 驳回【客户证件】
   */
  rejectApply(query) {
    return request.get(`${apiPath}/RejectCustomerCertificates`,{ params: query })
  },
  /**
   * 选项列表【用户标签分组】
   */
  options(){
     return request.get(`${apiPath}/options`)
  },
  fetchById(id){
    return request.get(`${apiPath}/${id}`)
  },
  agreeOrReject(data){
    return request.post(`${apiPath}/agreeOrReject`, data)
  },
  getDetail(id){
    return request.get(`${apiPath}/getRegistrationDetail/${id}`)
  },
  // 设置交易单号
  setPayNum(data){
    return request.post(`${apiPath}/setPayNum`, data)
  },
  /**
   * 分页查询【注册礼品列表】
   */
  registrationGiftList(query) {
    return request.get(`${apiPath}/registrationGiftList`, { params: query })
  },
  /**
   * 导出【注册礼品列表】
   */
  registrationGiftExport(query) {
    return request.get(`${apiPath}/registrationGiftExport`, { params: query })
  },
  /**
   * 初审【客户报名/身份变动】（财务审核）
   * @param {Object} data
   * @param {number} data.id 主键ID
   * @param {string} [data.bankNum] 线下收款标识
   * @param {boolean} data.isPass 是否通过
   * @param {string} [data.remarks] 备注/驳回原因
   * @param {number} [data.upgradeGiftAmount] 升级赠送额度
   */
  auditPre(data) {
    return request.post(`${apiPath}/teev2/auditPre`, data)
  }
}
export default customerRegistrationApi
